import React from "react";
import { CLINICAL_FORM_STATUS_LABELS } from "../../clinicalFormCatalog";

export const CLINICAL_FORM_STATUS_TONE = {
  pending: {
    wrap: "bg-slate-100 text-slate-700 border-slate-200",
    dot: "bg-slate-400",
  },
  send_to_office: {
    wrap: "bg-sky-50 text-sky-800 border-sky-200",
    dot: "bg-sky-500",
  },
  to_be_signed: {
    wrap: "bg-violet-50 text-violet-800 border-violet-200",
    dot: "bg-violet-500",
  },
  to_be_corrected: {
    wrap: "bg-amber-50 text-amber-800 border-amber-200",
    dot: "bg-amber-500",
  },
  completed: {
    wrap: "bg-emerald-50 text-emerald-800 border-emerald-200",
    dot: "bg-emerald-500",
  },
};

const ClinicalFormStatusBadge = ({ status, className = "" }) => {
  const tone = CLINICAL_FORM_STATUS_TONE[status] || {
    wrap: "bg-slate-100 text-slate-700 border-slate-200",
    dot: "bg-slate-400",
  };
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[11px] font-semibold border ${tone.wrap} ${className}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full shrink-0 ${tone.dot}`} />
      {CLINICAL_FORM_STATUS_LABELS[status] || status || "—"}
    </span>
  );
};

export default ClinicalFormStatusBadge;
